import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';

const PortalProgress = styled(LinearProgress)(({ theme }) => ({
  backgroundColor: '#efefef',
  height: 6,                
  borderRadius: 3,
  '& .MuiLinearProgress-bar': {
    backgroundColor: '#D4EB00',
  },
}));

const Loading = () => {
  return <PortalProgress variant='indeterminate' />;
};

export default Loading;
